import { render } from "./ArtworkCategory.vue?vue&type=template&id=68a9e2b0&scoped=true"
import script from "./ArtworkCategory.vue?vue&type=script&lang=js"
export * from "./ArtworkCategory.vue?vue&type=script&lang=js"

import "./ArtworkCategory.vue?vue&type=style&index=0&id=68a9e2b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68a9e2b0"]])

export default __exports__